// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Advisory Panel Styles - CSS Module */
.MvaHmi0zjxMqhuu7YkwC {
  position: absolute;
  top: 0;
  right: 0;
  width: 260px;
  height: 100%;
  z-index: 50;
  background: var(--vnsc-bg-primary);
  border-left: 1px solid var(--vnsc-border-primary);
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: var(--vnsc-text-primary);
  overflow: hidden;
}

._8R_29zrgUjxaaaMDlHE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 8px;
  border-bottom: 1px solid var(--vnsc-border-primary);
  background: var(--vnsc-bg-secondary);
}

.IK6C2UIxpcMRjUVf7rsz {
  font-weight: 700;
  font-size: 13px;
}

.Tgrl_EDrVNCsnPM21ihO {
  display: flex;
  gap: 6px;
}

.rcWBwNlQdrS_ieWHGDtp {
  background: none;
  border: 1px solid var(--vnsc-border-secondary);
  color: var(--vnsc-text-secondary);
  border-radius: 4px;
  cursor: pointer;
  padding: 2px 6px;
  font-size: 11px;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.rcWBwNlQdrS_ieWHGDtp:hover:not(:disabled) {
  background: var(--vnsc-bg-hover);
  color: var(--vnsc-text-primary);
  border-color: var(--vnsc-text-disabled);
}

.rcWBwNlQdrS_ieWHGDtp:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.lbpaPkZ3s43X0Saxu6Xy {
  background: none;
  border: none;
  color: var(--vnsc-text-tertiary);
  cursor: pointer;
  font-size: 14px;
  padding: 0 4px;
  transition: color 0.15s ease;
}

.lbpaPkZ3s43X0Saxu6Xy:hover {
  color: var(--vnsc-text-primary);
}

.b5EHK8oKnf_26xyp7Gfq {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

.eMjLYns52YCXZiI8VzSl {
  height: 40px;
  background: var(--vnsc-bg-tertiary);
  border-radius: 4px;
  margin-bottom: 8px;
  animation: fcNCuVQnb17IuBIMBblZ 1.2s ease-in-out infinite;
}

@keyframes fcNCuVQnb17IuBIMBblZ {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

.BM53JVhL97V76YFganK_ {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.pYTdcBnelyli_tBLIBhv {
  flex: 1;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.5px;
}

.r3GSLvMugdzR1ZBK9U2u {
  background: var(--vnsc-color-success-hover);
  color: var(--vnsc-text-on-primary);
}

.N0WpeZKKPJmEDdIsqPZW {
  background: var(--vnsc-color-success);
  color: var(--vnsc-text-on-primary);
}

.rzCgFlgSfweE8sJPWxSQ {
  background: var(--vnsc-color-neutral);
  color: var(--vnsc-text-on-primary);
}

.DESTu8tvQlmoWT9zyl4F {
  background: var(--vnsc-color-warning);
  color: var(--vnsc-text-on-primary);
}

.CF6e1NMe5FXcKYpzTgmR {
  background: var(--vnsc-color-error);
  color: var(--vnsc-text-on-primary);
}

.k2DfylfE56CPd31L69vh {
  text-align: center;
}

.vhG1qg1yVJJHCUciOxCV {
  color: var(--vnsc-text-tertiary);
  font-size: 10px;
}

.ihdraQcKclIQeeRBmPUu {
  font-weight: 700;
  font-size: 13px;
}

.F2k8klKZw0M2cIHKKlcb {
  margin-bottom: 8px;
}

.hi2YqGbicnsaylvrhgsH {
  border-bottom: 1px solid var(--vnsc-border-primary);
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.nktYn8GC5nF2czb8vz7o {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.LaUzjImCxzXSG_aNXDVH {
  flex: 1;
  font-size: 12px;
  color: var(--vnsc-text-primary);
  font-weight: 500;
}

.e1Xvhe3tYA8ObGmJkiDC {
  color: var(--vnsc-text-tertiary);
  font-size: 11px;
  margin-left: 4px;
}

.DbaZOERf4LxzfnkjYMp1 {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--vnsc-color-neutral);
  color: var(--vnsc-text-on-primary);
  letter-spacing: 0.5px;
}

.GG34ImslOGwbg1o77nCl {
  background: var(--vnsc-color-success);
}

.MrAKH451afbhVBOB7JGW {
  background: var(--vnsc-color-error);
}

.nrb2yMJGAOe3ceOtJTBf {
  background: var(--vnsc-color-neutral);
}

.O55kkW3oCWjt2qakYZix {
  color: var(--vnsc-text-tertiary);
  font-size: 10px;
}

.Uss7486k1ElcLSz1B53w {
  height: 4px;
  background: var(--vnsc-border-primary);
  border-radius: 2px;
  margin-top: 6px;
  overflow: hidden;
}

.ccZ8NCgqKXyAE7nNtYMa {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease;
}

.ZkWvGIZWjfBbKpIqRYDB {
  margin-top: 8px;
  font-size: 11px;
  color: var(--vnsc-text-secondary);
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.m7cm6WhSH0_xaH23aGKm {
  background: none;
  border: none;
  color: var(--vnsc-text-link);
  cursor: pointer;
  font-size: 11px;
  padding: 0;
  text-decoration: underline;
  transition: color 0.15s ease;
}

.m7cm6WhSH0_xaH23aGKm:hover {
  color: var(--vnsc-text-link-hover);
}

.WBdfkDRzHDG_FC0qEOCS {
  margin-top: 8px;
  font-size: 11px;
  color: var(--vnsc-text-secondary);
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.PRK_FggoKK5TfYIC_PF8 {
  margin-top: 10px;
  font-size: 10px;
  color: var(--vnsc-text-tertiary);
  text-align: right;
}

.qUfDYPSPKbg8H8kR4C3A {
  text-align: center;
  color: var(--vnsc-text-placeholder);
  padding-top: 24px;
  font-size: 12px;
}

.kyUME06akyLziw0O3fVI {
  font-size: 24px;
  margin-bottom: 8px;
}

@media (max-width: 480px) {
  .MvaHmi0zjxMqhuu7YkwC {
    width: 100%;
    height: auto;
    max-height: 50%;
    bottom: 0;
    top: auto;
    border-left: none;
    border-top: 1px solid var(--vnsc-border-primary);
  }
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/advisory-panel.module.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,yDAA0C;AAC5C;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,gDAAgD;EAClD;AACF","sourcesContent":["/* Advisory Panel Styles - CSS Module */\r\n.panel {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  width: 260px;\r\n  height: 100%;\r\n  z-index: 50;\r\n  background: var(--vnsc-bg-primary);\r\n  border-left: 1px solid var(--vnsc-border-primary);\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-primary);\r\n  overflow: hidden;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 12px 8px;\r\n  border-bottom: 1px solid var(--vnsc-border-primary);\r\n  background: var(--vnsc-bg-secondary);\r\n}\r\n\r\n.title {\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n}\r\n\r\n.headerActions {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.refreshBtn {\r\n  background: none;\r\n  border: 1px solid var(--vnsc-border-secondary);\r\n  color: var(--vnsc-text-secondary);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  padding: 2px 6px;\r\n  font-size: 11px;\r\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.refreshBtn:hover:not(:disabled) {\r\n  background: var(--vnsc-bg-hover);\r\n  color: var(--vnsc-text-primary);\r\n  border-color: var(--vnsc-text-disabled);\r\n}\r\n\r\n.refreshBtn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.closeBtn {\r\n  background: none;\r\n  border: none;\r\n  color: var(--vnsc-text-tertiary);\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  padding: 0 4px;\r\n  transition: color 0.15s ease;\r\n}\r\n\r\n.closeBtn:hover {\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 12px;\r\n}\r\n\r\n.skeletonRow {\r\n  height: 40px;\r\n  background: var(--vnsc-bg-tertiary);\r\n  border-radius: 4px;\r\n  margin-bottom: 8px;\r\n  animation: pulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% { opacity: 0.5; }\r\n  50% { opacity: 1; }\r\n}\r\n\r\n.decisionBadge {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.decisionLabel {\r\n  flex: 1;\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.decisionStrongBuy {\r\n  background: var(--vnsc-color-success-hover);\r\n  color: var(--vnsc-text-on-primary);\r\n}\r\n\r\n.decisionBuy {\r\n  background: var(--vnsc-color-success);\r\n  color: var(--vnsc-text-on-primary);\r\n}\r\n\r\n.decisionHold {\r\n  background: var(--vnsc-color-neutral);\r\n  color: var(--vnsc-text-on-primary);\r\n}\r\n\r\n.decisionSell {\r\n  background: var(--vnsc-color-warning);\r\n  color: var(--vnsc-text-on-primary);\r\n}\r\n\r\n.decisionStrongSell {\r\n  background: var(--vnsc-color-error);\r\n  color: var(--vnsc-text-on-primary);\r\n}\r\n\r\n.confidence {\r\n  text-align: center;\r\n}\r\n\r\n.confidenceLabel {\r\n  color: var(--vnsc-text-tertiary);\r\n  font-size: 10px;\r\n}\r\n\r\n.confidenceValue {\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n}\r\n\r\n.agentRows {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.agentRow {\r\n  border-bottom: 1px solid var(--vnsc-border-primary);\r\n  padding-bottom: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.agentHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.agentName {\r\n  flex: 1;\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-primary);\r\n  font-weight: 500;\r\n}\r\n\r\n.agentWeight {\r\n  color: var(--vnsc-text-tertiary);\r\n  font-size: 11px;\r\n  margin-left: 4px;\r\n}\r\n\r\n.agentSignal {\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  background: var(--vnsc-color-neutral);\r\n  color: var(--vnsc-text-on-primary);\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.agentSignalBuy {\r\n  background: var(--vnsc-color-success);\r\n}\r\n\r\n.agentSignalSell {\r\n  background: var(--vnsc-color-error);\r\n}\r\n\r\n.agentSignalHold {\r\n  background: var(--vnsc-color-neutral);\r\n}\r\n\r\n.agentExpand {\r\n  color: var(--vnsc-text-tertiary);\r\n  font-size: 10px;\r\n}\r\n\r\n.agentScoreBar {\r\n  height: 4px;\r\n  background: var(--vnsc-border-primary);\r\n  border-radius: 2px;\r\n  margin-top: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.agentScoreFill {\r\n  height: 100%;\r\n  border-radius: 2px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.agentExplanation {\r\n  margin-top: 8px;\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-secondary);\r\n  line-height: 1.5;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n}\r\n\r\n.explanationToggle {\r\n  background: none;\r\n  border: none;\r\n  color: var(--vnsc-text-link);\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n  padding: 0;\r\n  text-decoration: underline;\r\n  transition: color 0.15s ease;\r\n}\r\n\r\n.explanationToggle:hover {\r\n  color: var(--vnsc-text-link-hover);\r\n}\r\n\r\n.explanationContent {\r\n  margin-top: 8px;\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-secondary);\r\n  line-height: 1.6;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n}\r\n\r\n.timestamp {\r\n  margin-top: 10px;\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-tertiary);\r\n  text-align: right;\r\n}\r\n\r\n.emptyState {\r\n  text-align: center;\r\n  color: var(--vnsc-text-placeholder);\r\n  padding-top: 24px;\r\n  font-size: 12px;\r\n}\r\n\r\n.emptyIcon {\r\n  font-size: 24px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .panel {\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 50%;\r\n    bottom: 0;\r\n    top: auto;\r\n    border-left: none;\r\n    border-top: 1px solid var(--vnsc-border-primary);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `MvaHmi0zjxMqhuu7YkwC`,
	"header": `_8R_29zrgUjxaaaMDlHE`,
	"title": `IK6C2UIxpcMRjUVf7rsz`,
	"headerActions": `Tgrl_EDrVNCsnPM21ihO`,
	"refreshBtn": `rcWBwNlQdrS_ieWHGDtp`,
	"closeBtn": `lbpaPkZ3s43X0Saxu6Xy`,
	"body": `b5EHK8oKnf_26xyp7Gfq`,
	"skeletonRow": `eMjLYns52YCXZiI8VzSl`,
	"pulse": `fcNCuVQnb17IuBIMBblZ`,
	"decisionBadge": `BM53JVhL97V76YFganK_`,
	"decisionLabel": `pYTdcBnelyli_tBLIBhv`,
	"decisionStrongBuy": `r3GSLvMugdzR1ZBK9U2u`,
	"decisionBuy": `N0WpeZKKPJmEDdIsqPZW`,
	"decisionHold": `rzCgFlgSfweE8sJPWxSQ`,
	"decisionSell": `DESTu8tvQlmoWT9zyl4F`,
	"decisionStrongSell": `CF6e1NMe5FXcKYpzTgmR`,
	"confidence": `k2DfylfE56CPd31L69vh`,
	"confidenceLabel": `vhG1qg1yVJJHCUciOxCV`,
	"confidenceValue": `ihdraQcKclIQeeRBmPUu`,
	"agentRows": `F2k8klKZw0M2cIHKKlcb`,
	"agentRow": `hi2YqGbicnsaylvrhgsH`,
	"agentHeader": `nktYn8GC5nF2czb8vz7o`,
	"agentName": `LaUzjImCxzXSG_aNXDVH`,
	"agentWeight": `e1Xvhe3tYA8ObGmJkiDC`,
	"agentSignal": `DbaZOERf4LxzfnkjYMp1`,
	"agentSignalBuy": `GG34ImslOGwbg1o77nCl`,
	"agentSignalSell": `MrAKH451afbhVBOB7JGW`,
	"agentSignalHold": `nrb2yMJGAOe3ceOtJTBf`,
	"agentExpand": `O55kkW3oCWjt2qakYZix`,
	"agentScoreBar": `Uss7486k1ElcLSz1B53w`,
	"agentScoreFill": `ccZ8NCgqKXyAE7nNtYMa`,
	"agentExplanation": `ZkWvGIZWjfBbKpIqRYDB`,
	"explanationToggle": `m7cm6WhSH0_xaH23aGKm`,
	"explanationContent": `WBdfkDRzHDG_FC0qEOCS`,
	"timestamp": `PRK_FggoKK5TfYIC_PF8`,
	"emptyState": `qUfDYPSPKbg8H8kR4C3A`,
	"emptyIcon": `kyUME06akyLziw0O3fVI`
};
export default ___CSS_LOADER_EXPORT___;
